


























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { IStatRange } from "@/models/stats";

@Component
export default class DateRangeDropdown extends Vue {
  @Prop({ required: true })
  public ranges!: { [key: string]: IStatRange };

  @Prop({ required: true })
  public value!: IStatRange | null;

  @Prop({ default: false })
  public simple!: boolean;

  @Prop({ default: false })
  public time!: boolean;

  // Data
  public selected: IStatRange | null = this.value;

  public created() {
    if (this.value) {
      const index = this.$_.findIndex(
        this.rangesArray,
        i => i.key === this.$_.get(this.value, "key")
      );
      this.selectIndex(index);
    }
  }

  public get rangesArray() {
    return this.$_.toArray(this.ranges);
  }

  @Watch("value")
  public onValueChange(value) {
    const index = this.indexOfByDate(value);
    this.selected = this.$_.get(this.rangesArray, `[${index}]`, null);
  }

  @Watch("selected")
  public onSelectedChange(value) {
    const index = this.$_.indexOf(this.rangesArray, value);
    this.selectIndex(index);
  }

  public indexOfByDate(range) {
    return this.rangesArray.findIndex(i => {
      const [date1, date2] = range.dates;
      const granularity = this.time ? "minute" : "day";
      return (
        this.$moment(date1).isSame(i.dateFrom, granularity) &&
        this.$moment(date2).isSame(i.dateTo, granularity)
      );
    });
  }

  public selectIndex(index) {
    if (index >= 0 && index < this.rangesArray.length) {
      this.selected = this.rangesArray[index];
      this.$emit("input", this.selected);
    } else {
      this.selected = null;
    }
  }
}
